
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  data: () => ({
    papers: [] as any,
  }),
  mounted() {
    axios.get(Vue.prototype.apiUrl("publications")).then((response) => {
      this.papers = response.data || [];
    });
  },
});
